export default {
  total: 0,
  ads: [],
  adsInfo: [],
  translations: {}
}
